import React from 'react';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

export default function Footer(props) {
    console.log(props.stF)
  return (
    props.stF ?
    <footer
      style={{
        backgroundColor: '#000',
        color: 'white',
        padding: '2rem 1rem',
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
      }}
    >
      {/* Texte à gauche */}
      <div style={{ flex: 1, minWidth: '200px' }}>
        Ministère de l'Enseignement Supérieur, de la Recherche et de l'Innovation
        <small> © 2025 MESRI - Tous droits réservés</small>
      </div>

      {/* Liens externes à droite */}
      <div style={{ display: 'flex', flex: 2, justifyContent: 'flex-end', flexWrap: 'wrap', minWidth: '200px' }}>
        {/* Colonne 1 */}
        <div style={{ margin: '0 2rem 1rem 0' }}>
          <h4 style={{ marginBottom: '0.5rem' }}>Institutions</h4>
          <a href="https://www.mesri.gov.bf" target="_blank" rel="noopener noreferrer" style={{ color: 'white', display: 'block', marginBottom: '0.3rem' }}>MESRI</a>
          <a href="https://dgesup.gov.bf" target="_blank" rel="noopener noreferrer" style={{ color: 'white', display: 'block', marginBottom: '0.3rem' }}>DGESup</a>
          <a href="https://dri.gov.bf" target="_blank" rel="noopener noreferrer" style={{ color: 'white', display: 'block' }}>DGRI</a>
        </div>

        {/* Colonne 2 */}
        <div style={{ margin: '0 2rem 1rem 0' }}>
          <h4 style={{ marginBottom: '0.5rem' }}>Concepteur</h4>
          <a href="https://campusfaso.bf" target="_blank" rel="noopener noreferrer" style={{ color: 'white', display: 'block' }}>CampusFaso</a>
        </div>
      </div>
    </footer>
    :
    
    <footer
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        'background-color': 'black', /* Couleur de fond */
        color: 'white',         /* Couleur du texte */
        padding: '1rem',
        'text-align': 'left',     /* ou center selon le style */
        'z-index': 1000
      }}
    >
      {/* Texte à gauche */}
      <div style={{ flex: 1, minWidth: '200px' }}>
        Ministère de l'Enseignement Supérieur, de la Recherche et de l'Innovation
        <small> © 2025 MESRI - Tous droits réservés</small>
      </div>

      {/* Liens externes à droite */}
      <div style={{ display: 'flex', flex: 2, justifyContent: 'flex-end', flexWrap: 'wrap', minWidth: '200px' }}>
        {/* Colonne 1 */}
        <div style={{ margin: '0 2rem 1rem 0' }}>
          <h4 style={{ marginBottom: '0.5rem' }}>Institutions</h4>
          <a href="https://www.mesri.gov.bf" target="_blank" rel="noopener noreferrer" style={{ color: 'white', display: 'block', marginBottom: '0.3rem' }}>MESRI</a>
          <a href="https://dgesup.gov.bf" target="_blank" rel="noopener noreferrer" style={{ color: 'white', display: 'block', marginBottom: '0.3rem' }}>DGESup</a>
          <a href="https://dri.gov.bf" target="_blank" rel="noopener noreferrer" style={{ color: 'white', display: 'block' }}>DGRI</a>
        </div>

        {/* Colonne 2 */}
        <div style={{ margin: '0 2rem 1rem 0' }}>
          <h4 style={{ marginBottom: '0.5rem' }}>Concepteur</h4>
          <a href="https://campusfaso.bf" target="_blank" rel="noopener noreferrer" style={{ color: 'white', display: 'block' }}>CampusFaso</a>
        </div>
      </div>
    </footer>
  );
}
